import { useState } from 'react'
import { Navigate, useParams } from 'react-router'

import { LoadSummary } from '@/components/LoadSummary/LoadSummary'
import { useLoad } from '@/hooks/shipments/useLoad'
import { routes } from '@/routes'

import { useAddresses } from '../addresses/useAddress'
import { useCustomerRoutedDraft } from '../customer-routed/hooks'
import { BookingForm } from './BookingForm'
import { BookingFormProvider } from './BookingFormProvider'
import { TLBookingPageLayout } from './TLBookingPageLayout'

export const TLCustomerRoutedBookingPage = () => {
  const { loadId } = useParams()
  const draftLoads = useCustomerRoutedDraft()
  const loadQuery = useLoad(loadId, { enabled: !!loadId })
  const [activeTruckIndex, setActiveTruckIndex] = useState(0)

  const isExistingLoad = !!loadId

  const loads = isExistingLoad
    ? loadQuery.data
      ? [loadQuery.data]
      : undefined
    : draftLoads

  const activeLoad = loads?.[activeTruckIndex]
  const addressQuery = useAddresses(activeLoad)

  if (isExistingLoad) {
    if (loadQuery.isLoading) {
      return <TLBookingPageLayout isLoading />
    }

    if (!loadQuery.data?.isFreightCollect) {
      return <Navigate replace to="/pending" />
    }
  } else if (!loads?.length) {
    return <Navigate replace to={routes.quote('truckload')} />
  }

  if (!loads?.length || !activeLoad) {
    return null
  }

  return (
    <TLBookingPageLayout isLoading={addressQuery.loading}>
      <LoadSummary
        activeIndex={activeTruckIndex}
        isBooking
        load={activeLoad}
        numberOfTrucks={loads.length}
        selectTruck={setActiveTruckIndex}
      />

      <div className="flex min-h-0 min-w-0 flex-col h-full">
        <BookingFormProvider mode="customerRouted" loadsToBook={loads}>
          <BookingForm />
        </BookingFormProvider>
      </div>
    </TLBookingPageLayout>
  )
}
